import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On every route change, scroll the window back to the top.
 * Without this, navigating from a deep position on / to /privacy
 * (or vice-versa) preserves the previous scrollY and lands the
 * user mid-document.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
